module.exports = __webpack_public_path__ + "img/google_logo.18e5bb65.webp";